module.exports = __webpack_public_path__ + "img/reward.90378eb0.svg";